<template>
    <BreadCrumb PageTitle="Liste des types de chargement" />
    <ListeTypeChargement/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeTypeChargement from "@/components/TypeChargement/ListeTypeChargement.vue";
  
    export default defineComponent({
      name: "ListeTypeChargementPage",
      components: {
        BreadCrumb,
        ListeTypeChargement,
      },
    });
  </script>